import { DismissData, IframeAction, StorageType } from "../types";
import { getIframeData, updateStorageData } from "./iframe";
import { safeSessionStorage } from "./storage";

const SOFTWALL_DISMISSED_KEY = "BT_AM_SOFTWALL_DISMISSED";

export async function getDismissData(): Promise<DismissData | undefined> {
  const dismissDataStr = safeSessionStorage.get(SOFTWALL_DISMISSED_KEY);

  if (dismissDataStr) {
    return parseJSON(dismissDataStr);
  }

  return getIframeData(StorageType.Session, SOFTWALL_DISMISSED_KEY)
    .then((iframeData) => {
      if (iframeData) {
        // set data to session storage so on next page load
        // it will be available without need to post message to iframe
        safeSessionStorage.set(SOFTWALL_DISMISSED_KEY, iframeData);
        return parseJSON(iframeData);
      }
      return undefined;
    })
    .catch(() => undefined);
}

export async function hasDismissedData(): Promise<boolean> {
  if (safeSessionStorage.get(SOFTWALL_DISMISSED_KEY)) {
    return true;
  }
  return getIframeData(StorageType.Session, SOFTWALL_DISMISSED_KEY)
    .then((iframeData) => {
      if (iframeData) {
        // set data to session storage so on next page load
        // it will be available without need to post message to iframe
        safeSessionStorage.set(SOFTWALL_DISMISSED_KEY, iframeData);
        return true;
      }
      return false;
    })
    .catch(() => false);
}

export const saveDismissData = (dismissData: DismissData): Promise<void> =>
  updateStorageData(
    IframeAction.Set,
    StorageType.Session,
    SOFTWALL_DISMISSED_KEY,
    JSON.stringify(dismissData),
  );

export const deleteDismissedData = (): Promise<void> =>
  updateStorageData(
    IframeAction.Delete,
    StorageType.Session,
    SOFTWALL_DISMISSED_KEY,
  );

function parseJSON(data: string | null): DismissData | undefined {
  if (!data) return undefined;
  try {
    return JSON.parse(data);
  } catch {
    return undefined;
  }
}
